const GSM_BASIC = "@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
const GSM_EXTENDED = "^{}\\[~]|€\f";

const LIMITS = {
  "GSM-7": { single: 160, multi: 153 },
  "UCS-2": { single: 70, multi: 67 },
};

const REPLACEMENTS = {
  "‘": "'", "’": "'", "‚": "'", "′": "'",
  "“": "\"", "”": "\"", "„": "\"", "″": "\"",
  "–": "-", "—": "-",
  "…": "...",
  "→": "->",
  " ": " ",
};

const isGsm = (char) => GSM_BASIC.includes(char) || GSM_EXTENDED.includes(char);

export const smsSegments = (text) => {
  const chars = Array.from(text || "");
  const specialChars = [...new Set(chars.filter((char) => !isGsm(char)))];
  const encoding = specialChars.length ? "UCS-2" : "GSM-7";
  const length = encoding === "GSM-7"
    ? chars.reduce((sum, char) => sum + (GSM_EXTENDED.includes(char) ? 2 : 1), 0)
    : (text || "").length;
  const { single, multi } = LIMITS[encoding];
  const segments = length === 0 ? 0 : length <= single ? 1 : Math.ceil(length / multi);

  return { encoding, length, perSegment: segments > 1 ? multi : single, segments, specialChars };
};

export const replaceSpecialChars = (text) => Array.from(
  Array.from(text || "")
    .map((char) => REPLACEMENTS[char] ?? char)
    .join("")
)
  .filter(isGsm)
  .join("");
